import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import ClientDataNavUI from '../../../components/superUser/clientData/ClientDataNavUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import { Link } from 'react-router-dom'


const ChatFilesPageUI = ({ context, account, chatFilesList, onRefreshClick, onDocDownloadClick }) =>
  <SuperUserAccountPageUI context={context} className='pg_su_chat_files' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!chatFilesList}
    account={account} page='clientData' dimension='w768'
  >
    {
      !chatFilesList &&
      <SpinnerComponentUI />
    }
    {
      chatFilesList &&
      <div>
        <ChatFilesUI
          context={context}
          onRefreshClick={onRefreshClick}
        />
        {
          account &&
          <ClientDataNavUI account={account} page='chatFiles' />
        }
        {
          !chatFilesList.length &&
          <EmptyListUI className='g_m_top_200'
            context={context}
            createDisabledMessageLabel='No Chat Files data.'
          />
        }
        {
          chatFilesList.map((chatFile, i) =>
            <ChatFileRecordsUI key={i}
              context={context}
              account={account}
              chatFile={chatFile}
              onDocDownloadClick={onDocDownloadClick}
            />
          )
        }
      </div>
    }
  </SuperUserAccountPageUI>

const ChatFilesUI = ({ onRefreshClick }) =>
  <div>
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Client Data - Chat Files</b></span>
        </div>
      }
      right={<span />}
    />
  </div>

const ChatFileRecordsUI = ({ chatFile, onDocDownloadClick }) => (
  <div>
    <CardUI
      title={
        <>
          <span className="g_bold">File Name: </span>
          <Link
            className="g_m_right_50"
            onClick={onDocDownloadClick}
            to="#"
            data-file-id={chatFile.fileId}
            data-file-name={chatFile.fileName}
          >
            {chatFile.fileName}
          </Link>
        </>
      }
      className="g_m_top_100 g_normal"
    >
      <div className="g_muted g_small">Message Date: {chatFile.messageDateF1}</div>
    </CardUI>
  </div>
);


export default ChatFilesPageUI
